<template>
  <div class="flex-grow  flex flex-col overflow-hidden mt-2" data-ui="administration-overview">
    <div class="flex flex-grow overflow-hidden">
      <div class="overflow-auto flex-grow mr-2">

        <!-- projekte magazine  -->
        <div class="project-overview">
          <div v-if="selectProjekts" class="">
            <div class="flex-grow" data-ui="project-elements">
              <div v-for="(project, pIndex) in finalProjectList" :key="project.projectId" class="mb-1 overflow-auto bg-trader-gray" :class="(specificProjectId != 0 && pIndex == 0) ? ' mb-10' : '' ">


              <div class="w-full flex flex-wrap   p-1  items-center" :data-ui="'project-title-bar-' + project.name" :class="(specificProjectId != 0 && pIndex == 0) ?'bg-trader-blue text-white':'bg-trader-dark-gray' ">

                  <div class="w-24 flex items-center justify-center" >
                    <div @click="deleteTrue(project.projectId, 'project')" :data-ui="'delete-true-'+ project.name +''"
                         class="hover:bg-trader-blue hover:text-white w-10 h-10 flex justify-center items-center cursor-pointer">
                      <i class="fa-solid fa-trash" ></i>
                    </div>
                    <div @click="lockTrueProject(project.projectId)" :data-ui="'lock-true-project-'+ project.name"
                         class="hover:bg-trader-blue hover:text-white w-10 h-10 flex justify-center items-center cursor-pointer">
                      <i v-if="project.lock" class="fa-solid fa-lock text-red-400"
                         :class="[project.lock ? '' : 'text-black']"></i>
                      <i v-else class="fa-solid fa-lock-open text-green-500"> </i>
                    </div>
                  </div>


                    <div class=" flex text-center items-center   flex-grow" :data-ui="'project-title-'+ project.name +''">
                      <span class="text-xl font-bold text-left flex-grow pr-4" data-ui="project-name">{{ project.name }}</span>
                      <CreatProjekt :project-id-prop="project.projectId" :over-view="true" />
                    </div>


                </div>

                <div class="flex mt-1 mb-10" >
                  <div class="w-full ">

                    <div class="flex flex-wrap" data-ui="magazine-elements">
                      <div v-for="magazine in project.magazines" :key="magazine.magazineId"
                           class=" p-2 rounded flex  min-w-[350px] max-w-[350px] mb-2 h-[150px] bg-white m-3"  :data-ui="'magazine-preview-' + magazine.name"
                           :class="(specificProjectId != 0 && pIndex == 0) ?'':'' ">
                        <div
                            class="h-full max-w-[87px] min-w-[87px] mr-2 cursor-pointer"
                            @click="goToPage(magazine.magazineId, project.projectId)">

                          <object
                              class="w-full h-full pointer-events-none"
                              type="image/svg+xml"
                              :data="'/api/v3/preview/magazine/' + magazine.magazineId"
                              :data-ui="'magazine-page-preview-' + magazine.name">
                            <param name="type" value="image/svg+xml">
                          </object>

                        </div>

                        <div class="ml-2">
                          <div class="flex w-full">
                            <!-- Magazin name Container -->
                            <div :data-ui="'magazine-title-'+ magazine.name"
                                 @click="goToPage(magazine.magazineId,project.projectId)"
                                 class=" justify-center flex flex-col cursor-pointer min-w-[130px]">
                              <span class="font-bold mb-1 inline-block cursor-pointer">{{ magazine.name }}</span>
                            </div>
                            <div class="flex items-center justify-center grid-cols-3 gap-2">
                              <!-- text Kopieren -->
                              <div @click="copyToClipboard(magazine.name)"
                                   title="Namen kopieren"
                                   :data-ui="'copy-magazine'+ magazine.name"
                              class="hover:bg-trader-blue hover:text-white p-2 flex justify-center items-center cursor-pointer">
                                <i class="fa-regular fa-clipboard"></i>
                              </div>
                              <!-- Löschen -->
                              <div @click="deleteTrue(magazine.magazineId, 'magazine')"
                                   title="Magazine Löschen"
                                   :data-ui="'delete-magazine'+ magazine.name"
                                   class="hover:bg-trader-blue hover:text-white p-2 flex justify-center items-center cursor-pointer">
                                <i class="fa-solid fa-trash" :data-ui="'delete-magazine-'+magazine.name+''"></i>
                              </div>
                              <!-- Locken -->
                              <div @click="lockTrue(magazine.magazineId)"
                                    title="Magazine Speeren"
                                   :data-ui='"lock-magazine-" + magazine.name'
                                   class="hover:bg-trader-blue hover:text-white p-2 flex justify-center items-center cursor-pointer">
                                <i v-if="magazine.lock" class="fa-solid fa-lock text-red-400" :class="[magazine.lock ? '' : 'text-black']"></i>
                                <i v-else class="fa-solid fa-lock-open text-green-500"></i>
                              </div>
                            </div>
                          </div>
                          <table>
                            <tr >
                              <td>Größe:</td>
                              <td :data-ui="'magazine-dimensions' + magazine.name">{{magazine.mmW}} x {{ magazine.mmH}} mm</td>
                            </tr>
                            <tr>
                              <td>Seiten:</td>
                              <td :data-ui="'number-of-pages' + magazine.name"> {{ magazine.numberOfPages }}</td>
                            </tr >
                            <tr>
                              <td>Vom:</td>
                              <td :data-ui="'from-date' + magazine.name"> {{formatDate(magazine.from)}}  </td>
                            </tr>
                            <tr>
                              <td>Bis:</td>
                              <td :data-ui="'to-date' + magazine.name"> {{formatDate(magazine.to)}}</td>
                            </tr>
                            <tr>
                              <td>Druck-Nr:</td>
                              <td :data-ui="'to-date' + magazine.printNumber">{{magazine.printNumber}} </td>
                            </tr>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <sidebar :get-project-id="getProjectId" />

    </div>
  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import apolloClient from "../../../apolloClient";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import ProductFormular from "@/components/ProductFormular/ProductFormular.vue";
import Accordion from "@/components/Accordion/Accordion.vue";
import ProductHeader from "@/components/ProductFormular/ProductHeader.vue";
import PageGrid from "@/components/PageGrid/PageGrid.vue";
import router from "@/router";
import sidebar from "@/components/Administration/Sidebar.vue";
import CreatProjekt from "@/components/Administration/Project/CreatProjekt.vue";
import ShowPreview from "@/components/Preview/ShowPreview.vue";
import SignalBus from "@/application/SignalBus";
import Modal from "@/components/Dialogs/Modal.vue";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import {query} from "@/graphql";
//import accordionAdministration from "@/views/Sidebar.vue";
export default {

  components: {
    ShowPreview,
    ProductHeader, Accordion, ProductFormular, AccordionItem, PageGrid, sidebar, CreatProjekt, Modal
  },
  data() {
    return {
      projectData: {projects: []},
      selectedProject: true,
      magazineId: null,
      hideContent: true,
      specificProjectId: 0,
      magazineName: "",
      selectedOption: "Hochformart",
      selectedSize: "A4",
      widthInMm: "",
      heightInMm: "",
      selectProjekts: true,
      showPage: false,
      showUserPage: false,
      userSearch: '',
      active: 0,
      userData: {
        users: [],
      },
      deleteMagazineTrue: false,
    };
  },
  computed: {
    specificProject() {

      return this.projectData.projects.find(project => project.projectId ==  this.specificProjectId);
    },
    finalProjectList() {
      let first10Projects = this.projectData.projects.slice(0, 10);
     if (this.specificProject) {
        // Fügt das Projekt oben hinzu
        first10Projects.unshift(this.specificProject);
      }
      return first10Projects;
    }
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        
      }).catch(err => {
        console.error('Failed to copy text: ', err);
      });
    },
    getProjectId(id) {
      this.specificProjectId = id;
    },
    magazine() {
      return magazine
    },
    reloadPage() {
      this.fetchProjects();
    },
    deleteTrue(id, type) {
      if (type === "magazine") {
        eventBus.openConfirm({
          title: "Magazin",
          message: "Möchten Sie dieses Magazin wirklich löschen?",
          onAccept: () => {
            this.deleteMagazine(id);
          }
        });
      } else if (type === "project") {
        eventBus.openConfirm({
          title: "Projekt",
          message: "Möchten Sie dieses Projekt wirklich löschen?",
          onAccept: () => {
            this.deleteProject(id);
          }
        });
      }
    },
    async deleteMagazine(id) {
      const mutation = gql`
        mutation deleteMagazine($magazineId: Int!) {
          deleteMagazine(magazineId: $magazineId) {
            success
          }
        }
      `;

      try {
        const variables = {
          magazineId: id
        };
        const {data} = await apolloClient.mutate({mutation, variables});

        if (data.deleteMagazine.success){
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Magazine gelöscht",
            message: "Der Magazine wurde gelöscht",
          });
          router.push('/administration');
        }
        await this.fetchProjects();
        SignalBus.emit("sidebar-reload-projects");


      } catch (error) {
        console.error(error);
      }
    },
    async lockTrue(magazineId) {
      const mutation = gql`
        mutation changeMagazineLock($magazineId: Int!) {
          changeMagazineLock(magazineId: $magazineId) {
            success
          }
        }
      `;

      try {
        const variables = {
          magazineId: magazineId
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        await this.fetchProjects();
      } catch (error) {
        console.error(error);
      }
    },
    async deleteProject(id) {
      const mutation = gql`
        mutation deleteProject($projectId: Int!) {
          deleteProject(projectId: $projectId) {
            success
          }
        }
      `;

      try {
        const variables = {
          projectId: id
        };
        const {data} = await apolloClient.mutate({mutation, variables});

        if (data.deleteProject.success){
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Projekt gelöscht",
            message: "Das Projekt wurde gelöscht",
          });
          router.push('/administration');
        }
        SignalBus.emit("sidebar-reload-projects");
        await this.fetchProjects();
      } catch (error) {
        console.error(error);
      }
    },
    async lockTrueProject(projectId) {
      const mutation = gql`
        mutation changeProjectLock($projectId: Int!) {
          changeProjectLock(projectId: $projectId) {
            success
          }
        }
      `;
      try {
        const variables = {
          projectId: projectId
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        this.fetchProjects();
      } catch (error) {
        console.error(error);
      }
    },
    goToPage(magazine, projekt) {
      router.push(`/administration/` + this.active + `/page/` + projekt + `/` + magazine + `/` + 1 + `/` + 0);
    },
    formatDate(unixTimestamp) {
      const date = new Date(unixTimestamp * 1000); // Das Multiplizieren mit 1000 ist notwendig, da JavaScript Millisekunden erwartet.
      return date.toLocaleString(); // Dies gibt das Datum und die Uhrzeit in einem lokalisierten Format zurück.
    },
    toggleButton(option) {
      this.selectedOption = option;
    },
    async fetchProjects() {
      try {

        const response = await apolloClient.query({
          query: gql`
            query GetProjectDetails {
              projects {
                lock
                projectId
                name
                magazines {
                  magazineId
                  name
                  lock
                  numberOfPages
                  from
                  to
                  mmH
                  mmW
                  printNumber

                }
              }
            }
          `
        });

        this.projectData = response.data;

        if (this.projectData.length > 0) {
          this.pageId = this.projectData.projects[0].magazines[0].pages[0].pageId;
        }
      this.projectData.projects.forEach(project => {
        project.magazines.forEach(magazine => {
          // Konvertiere die Werte von mmH und mmW in Zahlen, entferne überflüssige Nullen und formatiere sie
          magazine.mmH = parseFloat(parseFloat(magazine.mmH).toFixed(5)).toString();
          magazine.mmW = parseFloat(parseFloat(magazine.mmW).toFixed(5)).toString();
        });
      });

      } catch (error) {
        console.error("Fehler beim Abrufen der Projektdaten:", error);
      }
    },
    updateAccordion(newId) {
      this.active = newId;
    },
  },
  created() {
    this.specificProjectId = this.$route.params.projectId
    this.updateAccordion(this.$route.params.accordionIndex);
  },
  watch: {
    selectedSize() {
      this.updateSize();
    },
    '$route.params': {
      handler: function (params) {
        this.specificProjectId = params.projectId;
      },
    }

  },
  mounted() {
    this.fetchProjects();
    this.updateAccordion(this.$route.params.accordionIndex);
    this.specificProjectId = this.$route.params.projectId
    SignalBus.connect(this,"sidebar-reload-projects", this.fetchProjects);
    SignalBus.connect(this,"sidebar-reload-magazine", this.fetchProjects);
    SignalBus.connect(this,"delete-project", this.deleteProject);
  },
  beforeUnmount() {
    SignalBus.disconnectAllFromParent(this);
  },
};
</script>

